// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIrsLimitDto
 */
export interface IIrsLimitDto {
    /**
     * 
     * @type {number}
     * @memberof IIrsLimitDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IIrsLimitDto
     */
    type?: IIrsLimitDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IIrsLimitDto
     */
    tax_year?: number;
    /**
     * 
     * @type {Date}
     * @memberof IIrsLimitDto
     */
    tax_year_end?: Date;
    /**
     * 
     * @type {number}
     * @memberof IIrsLimitDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IIrsLimitDto
     */
    frequency_type?: IIrsLimitDtoFrequencyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IIrsLimitDto
     */
    irs_coverage_level_type?: IIrsLimitDtoIrsCoverageLevelTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIrsLimitDtoTypeEnum {
    HCFSA_MAX = 'HCFSA_MAX',
    HSA_MAX = 'HSA_MAX',
    DCAP_MAX = 'DCAP_MAX',
    TRANSIT_MAX = 'TRANSIT_MAX',
    PARKING_MAX = 'PARKING_MAX',
    HCFSA_EE_ER_MAX = 'HCFSA_EE_ER_MAX'
}
/**
* @export
* @enum {string}
*/
export enum IIrsLimitDtoFrequencyTypeEnum {
    MONTHLY = 'MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IIrsLimitDtoIrsCoverageLevelTypeEnum {
    FAMILY = 'FAMILY',
    INDIVIDUAL = 'INDIVIDUAL',
    ROLLOVER = 'ROLLOVER'
}


/**
 * Check if a given object implements the IIrsLimitDto interface.
 */
export function instanceOfIIrsLimitDto(value: object): value is IIrsLimitDto {
    return true;
}

export function IIrsLimitDtoFromJSON(json: any): IIrsLimitDto {
    return IIrsLimitDtoFromJSONTyped(json, false);
}

export function IIrsLimitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIrsLimitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'tax_year_end': json['tax_year_end'] == null ? undefined : (new Date(json['tax_year_end'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'irs_coverage_level_type': json['irs_coverage_level_type'] == null ? undefined : json['irs_coverage_level_type'],
    };
}

export function IIrsLimitDtoToJSON(json: any): IIrsLimitDto {
    return IIrsLimitDtoToJSONTyped(json, false);
}

export function IIrsLimitDtoToJSONTyped(value?: IIrsLimitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'tax_year': value['tax_year'],
        'tax_year_end': value['tax_year_end'] == null ? undefined : ((value['tax_year_end']).toISOString()),
        'amount': value['amount'],
        'frequency_type': value['frequency_type'],
        'irs_coverage_level_type': value['irs_coverage_level_type'],
    };
}

